import React from 'react';
import PropTypes from 'prop-types';
import { CrossIcon } from '../../atom/CrossIcon/CrossIcon';

/** 
 * A stateless component for Desktop Filter tag.
 * Filter tag provide common functionality of Filter tag.
 * Filter tag provide the feature:As user select any options, the tag appears with cross icon.
*/
const DesktopFilterTag = (props) => {

    return (
        <div className="jp-desktop-filter-tag-container" id="focus">
            {props.selectedfilter.map((element, index) => (
                <span key={index} title={element.name} role="presentation" className="jp-desktop-filter-tag-label"><span>{element.name}</span>
                    <CrossIcon parentClassName='jp-crossIcon' tabIndex="0" role="button" title={'Close ' + element.name} aria-label='' onClick={() => props.handleFilterDelete(element)} />
                </span>
            )
            )}
        </div>
    );
};

DesktopFilterTag.defaultProps = {
    /** Specify the selected value of the Selected Filter */
    selectedfilter: [],

};

DesktopFilterTag.propTypes = {
    /** selected value of the Selected Filterto apply on element */
    selectedfilter: PropTypes.array.isRequired,
    /** Subscribe to delete events */
    handleFilterDelete: PropTypes.func,

};

export default DesktopFilterTag;

